import { Queries as CommonQueries } from '@aline/common';

import { locationQueries } from './location';

export const Queries = {
  ...CommonQueries,
  ...locationQueries,
};
